// extracted by mini-css-extract-plugin
export default {"container":"loader_container__OPJo1","wrapper":"loader_wrapper__ZsVIK"};